import { MERGE_APP_PATH, OAUTH_CALLBACK_PATH } from "../../../../../../router/RouterUtils";

export const NoMergeCredentialsText =
  "Using your own credentials means your logo will be displayed in the pop-up when your users link, offering a branded experience. Data access will also often be restricted to the scopes of your app.";

export const MergeProvidedCredentialsText =
  "Merge provides credentials for this integration, but you can also use your own credentials. This means your logo will be displayed in the pop-up when your users link, offering a branded experience. Data access will also often be restricted to the scopes of your app.";

export enum CredentialChoices {
  MERGE = "merge-credentials",
  CUSTOMER = "customer-credentials",
}

// The OAuth redirect URI is the same for every customer OAuth app, so we pre-populate it
// as a read-only, copyable value rather than asking customers to type it in.
export const OAUTH_REDIRECT_URI_FIELD_NAME = "oauth_redirect_uri";
// The customer OAuth callback is centralized on the NA host (app.merge.dev) for every tenant,
// including EU/APAC/single-tenant, matching the backend's DEFAULT_CUSTOMER_OAUTH_CREDENTIAL_REDIRECT_URI.
// It is intentionally NOT derived from the current tenant host: the value written here is read
// back as the redirect_uri sent to the provider, so it must match the callback the backend serves.
export const DEFAULT_OAUTH_REDIRECT_URI = `${MERGE_APP_PATH}${OAUTH_CALLBACK_PATH}`;
